var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconBase',{class:_vm.rotationClass,attrs:{"icon-name":"arrow","width":"10","height":"10"}},[_c('path',{attrs:{"d":"M 2 3 h 6 l-3 4z","stroke":"#000","fill":"#000"}})])}
var staticRenderFns = []

export { render, staticRenderFns }